import Navbar from '../../components/sections/Navbar';
import Footer from '../../components/sections/Footer';

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <div className='container privacy'>
        <h1 className='privacy-header'>MY HERO Privacy Policy</h1>
        <strong className='p-strong'>
          When you use our services, you're trusting us with your information.
          We understand this is a big responsibility and work hard to protect your information and put you in control.
        </strong>
        <p className='p'>
          By accessing or using the Services, you agree to this Privacy Policy, and our <a href='/terms' target='blank'>Terms of Service</a>.
          If you have any questions about this Privacy Policy, you can <a href='mailto:myheroapplication@gmail.com' target='blank'>contact us</a>.
        </p>

        <div className='section'>
          <h2>Information MY HERO Collects</h2>
          <h3>Your activity & apps</h3>
          <p>
            At the time you register for MY HERO, you voluntarily give us information such as your name and email address.
             You have the access and can update this information under your personal Account Settings at any time. 
             We also collect aggregated, anonymous user data about the use of the app.
          </p>
        

          <h3>Your browsers & devices</h3>
          <p>
            We collect information about the browsers and devices you use to access MY HERO. 
            The user data we collect is used to enhance MY HERO and the quality of our service.
            We only collect personal data required to deliver our services, and we only store it to the extent that it is essential to perform these services.
          </p>

          <h3>Your Location Information</h3>
          <p>
            We collect information about your location after you open background location access to MY HERO.
            The location data is used to help us offer the Location Reminder feature. 
            Your location can be determined by Sensor data from your device.
              You can turn your Android device's location on or off using the device’s settings app.
          </p>
        </div>

        <div className='section'>
          <h2>Why MY HERO Collects Data</h2>
          <p>
            We use data to build better services.
             Your information will not be shared with others and will only be used internally for the purposes described below:
          </p>

          <h3>Provide our services</h3>
          <p>
            We use your information to deliver our services or information you requested,
             and to process and complete any transactions.
          </p>
        
          <h3>Maintain & improve our services</h3>
          <p>
            We also use your information to ensure our services are working as intended, 
             such as tracking outages or troubleshooting issues that you report to us. 
             And we use your information to make improvements to our services - for example, to analyze usage and trends with anonymous user data,
             and to improve the quality of our service and user experience.
          </p>

          <h3>Communicate with you</h3>
          <p>
            MY HERO collects email addresses from those who communicate with us via email, 
             as well as information provided through voluntary activities such as site registration or survey participation.
             We use the information we collect to interact with you directly. 
          </p>

          <h3>Protect MY HERO, our users, and the public</h3>
          <p>
            We use information to help improve the safety and reliability of our services.
             This includes detecting, preventing, and responding to fraud, abuse, security risks,
             and technical issues that could harm MY HERO, our users, or the public.
          </p>
          <p>
            We use different technologies to process your information for these purposes.
             We'll ask for your consent before using your information for a purpose that isn't covered in this Privacy Policy. 
          </p>
          <p>
            You're also welcome to <a href='mailto:myheroapplication@gmail.com' target='blank'>contact us </a> 
              to ask for our confirmation whenever you feel concerned about how your personal information is being processed,
             where and for what purpose.
          </p>
        </div>

        <div className='section'>
          <h2>Your Privacy Controls</h2>
          <p>
            While MY HERO owns the My HERO application's code, databases, and all rights, you retain all rights to your data.
             You have choices regarding the information we collect and how it's used. 
             MY HERO will never sell your personal data with a third party, and we will never share data to third parties without your permission.
             When absolutely necessary, My HERO uses third party services and hosting partners who are GDPR-compliant. 
             In such instances, we take essential security methods to guarantee that we comply with GDPR when sending and receiving data from third parties.
          </p>
        </div>

        <div className='section'>
          <h2>Cookies</h2>
          <p>
            Cookies are required on MY HERO's Website.
             We use them to collect visitors' preferences and thus to better optimize the user experience. 
             Users can disable cookies in their browser settings.
             But please note that our services rely on cookies to function properly,
             and you may not be able to access certain features on our Website after disabling them.
          </p>
        </div>

        <div className='section'>
          <h2>Data Retention & Secure</h2>
          <p>
            MY HERO is built with strong security features that continuously protect your information.
             SSL protocol secures all data and information transmitted with Service.
             The insights we gain from maintaining our services help us detect and automatically block security threats from ever reaching you.
             And if we do detect something risky that we think you should know about,
             we'll notify you and help guide you through steps to stay better protected.
          </p>

          <p>
            We work hard to protect you and MY HERO from unauthorized access, alteration,
             disclosure, or destruction of information we hold.
             You can learn more about our security measures from the <a href='/security' target='blank'>Security </a> page. 
          </p>

          <h3>How long we store your information</h3>
          <p>
            We keep the information until you delete your account,
             and the information will keep in our backup archives for 90 days after the account is deleted.
             For subscriptions and transaction records,we retain this information after the account is deleted.
          </p>
        </div>

        <div className='section'>
          <h2>Data Deletion</h2>
          <p>
            You can delete your MY HERO account with "Avatar - Settings - Account and Security" in MY HERO website.
             If you terminate your Account, any association between your Account and information we store will no longer be accessible through your Account.
             We will stop providing products and/or services to you and delete your personal information as required by you.
          </p>
        </div>

        <div className='section'>
          <h2>Changes to This Policy</h2>
          <p>
            If our Privacy Policy changes at some time in the future, we will not reduce your rights under this Privacy Policy without your explicit consent.
             We always indicate the date the latest changes were published.
             If changes are significant, we'll provide a more prominent notice (including, for certain services, email notification of Privacy Policy changes).
          </p>

          <p>
            Please check back periodically to keep informed of updates or changes to this Privacy Policy.
             By continuing to access and to use MY HERO, you are agreeing to be bound by the revised policy.
          </p>
        </div>

        <div className='last-revision'>
          <p>
            To read more details and frequently asked questions about MY HERO’s privacy and terms,
             please read the Privacy and Security FAQ in our Help Center. 
          </p>
          <br/>
          <p>Date of Last Revision : Oct 1, 2022</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;